"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductHero2ViewLeft = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const components_1 = require("./components");
const lib_1 = require("../../../lib");
function ProductHero2ViewLeft({ product, contactOnly, onProductAdd, onFallbackClick, fallbackText = 'Contact for purchase', available = true, buyText = 'Buy', prefix, suffix, }) {
    const { addProduct, openCart } = (0, lib_1.useCart)();
    const handleClick = (0, react_1.useCallback)(() => {
        if (contactOnly) {
            onFallbackClick === null || onFallbackClick === void 0 ? void 0 : onFallbackClick();
        }
        else {
            void addProduct(product.variants[0].id, onProductAdd !== null && onProductAdd !== void 0 ? onProductAdd : openCart);
        }
    }, [
        addProduct,
        contactOnly,
        onFallbackClick,
        onProductAdd,
        openCart,
        product.variants,
    ]);
    const text = contactOnly ? fallbackText : available ? buyText : 'Sold out';
    return ((0, jsx_runtime_1.jsxs)(components_1.LeftPanel, Object.assign({ noCenter: true }, { children: [prefix === null || prefix === void 0 ? void 0 : prefix({ product }), (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "h2", as: "h4" }, { children: product.title })), (0, jsx_runtime_1.jsx)(lib_1.RichText, { value: product.description }), suffix === null || suffix === void 0 ? void 0 : suffix({ product }), (0, jsx_runtime_1.jsx)(components_1.BuyButton, Object.assign({ kind: "ghost", onClick: handleClick }, { children: text }))] })));
}
exports.ProductHero2ViewLeft = ProductHero2ViewLeft;
